// Objeto para almacenar las clases originales de cada elemento
const originalClasses = new Map();

// Función para guardar las clases originales
function saveOriginalClasses() {
    const gridMediaChildren = document.querySelectorAll('.gallery.grid > div');
    gridMediaChildren.forEach((child, index) => {
        // Guardar las clases originales en el objeto
        originalClasses.set(index, child.className);
    });
}

// Función para obtener el breakpoint del atributo data-breakpoint
function getBreakpoint() {
    const galleryGrid = document.querySelector('.gallery.grid');
    if (galleryGrid && galleryGrid.dataset.breakpoint) {
        return parseInt(galleryGrid.dataset.breakpoint, 10); // Convertir a número
    }
}

// Función para actualizar las clases en dispositivos móviles
function updateClassesForMobile() {
    const gridMediaChildren = document.querySelectorAll('.gallery.grid > div');
    const breakpoint = getBreakpoint();

    if (window.matchMedia(`(max-width: ${breakpoint}px)`).matches) {
        // Modo móvil
        gridMediaChildren.forEach((child, index) => {
            // Guardar las clases originales si no se han guardado antes
            if (!originalClasses.has(index)) {
                originalClasses.set(index, child.className);
            }

            // Obtener las clases actuales del elemento
            const classes = child.className.split(' ');

            // Filtrar y reemplazar las clases que comienzan con row-span- o lg:col-span-
            const updatedClasses = classes.map((cls) => {
                if (cls.startsWith('row-span-')) {
                    return 'row-span-1'; // Reemplazar con row-span-1
                } else if (cls.startsWith('lg:col-span-')) {
                    return 'lg:col-span-1'; // Reemplazar con lg:col-span-1
                }
                return cls; // Mantener las otras clases sin cambios
            });

            // Unir las clases actualizadas y asignarlas al elemento
            child.className = updatedClasses.join(' ');

            // Agregar las clases adicionales si no están ya presentes
            const additionalClasses = ['block', 'relative', 'flex', 'flex-col', 'gallery-block', 'h-full'];
            additionalClasses.forEach((cls) => {
                if (!child.classList.contains(cls)) {
                    child.classList.add(cls);
                }
            });
        });
    } else {
        // Modo escritorio: restaurar las clases originales
        gridMediaChildren.forEach((child, index) => {
            if (originalClasses.has(index)) {
                child.className = originalClasses.get(index); // Restaurar clases originales
            }
        });
    }
}

// Guardar las clases originales al cargar la página
window.addEventListener('load', () => {
    saveOriginalClasses();
    updateClassesForMobile(); // Aplicar cambios iniciales
});

// Actualizar las clases al redimensionar la ventana
window.addEventListener('resize', updateClassesForMobile);